import React from 'react';

function Footer() {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <div className="footer">
      <p className="paragraph-s paragraph-bold">
        &copy; Marius Pepelea | {year} - Book Library
      </p>
    </div>
  );
}

export default Footer;
